import React from 'react';

import {
  useLocation,
  useParams,
} from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { selectedMenu } from 'state';
import styled from 'styled-components';
import {
  AdminSideMenu,
  BodyContainer,
  Header,
    MainContainer,
} from 'view/components';
import Classes from 'view/pages/Classes/Classes';
import Coaching from 'view/pages/Coaching/Coaching';
import Communication from 'view/pages/Communication/Communication';
import Dashboard from 'view/pages/Dashboard/Dashboard';
import Members from 'view/pages/Members/Members';
import Profile from "../Profile/Profile";
import Live from "../Live/Live";

interface StyledComponentProps {
    width?: string;
    display?: string;
}

const Home = () => {
    const menu = useRecoilValue(selectedMenu);
    const location = useLocation();
    const params = useParams()
    const el = () => {        
        switch (params?.depth1) {
            case "dashboard": {
                return <Dashboard />;
            }
            case "classes": {
                return <Classes />;
            }
            case "coaching": {
                return <Coaching />;
            }
            case "communication": {
                return <Communication />;
            }
            case "members": {
                return <Members />;
            }
            case "profile": {
                return <Profile/>;
            }
            case "live": {
                return <Live/>;
            }
            default:
                break;
        }
    };

    console.log('location', location, params)

    return (
        <Container>
            <BodyContainer>
                <ContentsWrap>
                    <AdminSideMenu isAdmin={true} />
                    <Wrap>
                    <Header/>
                    <MainContainer>{el()}</MainContainer>
                    </Wrap>
                </ContentsWrap>
            </BodyContainer>
        </Container>
    );
};
export default Home;

const Container = styled.div`
    display: flex;
    transition: all 0.2s;
    position: relative;
    
`;
const ContentsWrap = styled.div`
    display: flex;
    width: calc(100% - 298);
    max-width: 1440px;
    height: 100%;
    margin: auto;
`;
const Wrap = styled.div`
    width: 100%;
    height: 100%;
    overflow-y: hidden;
    flex: 1;
    @media screen and (max-width: 768px) {
        position: absolute;
    }
`;
const BannerContents = styled.div`
    width: 1048px;
    height: 100%;
    position: absolute;
    z-index: 1;
    padding: 25px 20px;
    background: linear-gradient(269.04deg, rgba(0, 0, 0, 0) 39%, rgba(0, 0, 0, 0.75) 79.51%);
    h2 {
        text-transform: uppercase;
        color: #fff;
        font-size: 28px;
        font-weight: 600;
        margin-bottom: 10px;
        opacity: 0.9;
        line-height: 35.28px;
    }
    p {
        opacity: 0.8;
        color: #fff;
        width: 470px;
        line-height: 24px;
        font-size: 18px;
        margin-bottom: 30px;
    }
`;
const Create = styled.div`
    background: #ddc160;
    font-size: 14px;
    border-radius: 6px;
    display: inline-block;
    align-items: center;
    padding: 10px 18px;
    cursor: pointer;
    img {
        width: 16px;
        height: 16px;
    }
`;
const CreateContents = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;

    span {
        line-height: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        font-size: 16px;
        font-weight: 600;
        margin-left: 10px;
    }
`;
